import { fetchNextPage } from "services/Onboarding";
import { STEP_NAMES } from "common/constants/Onboarding";

export const ONBOARDING_NEXT_STEP = "ONBOARDING_NEXT_STEP";
export const ONBOARDING_PREVIOUS_STEP = "ONBOARDING_PREVIOUS_STEP";
export const ONBOARDING_ADD_STEP = "ONBOARDING_ADD_STEP";

const DEFAULT_STATE = {
    currentStep: 0,
    stepData: []
};

export function onboardingReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case ONBOARDING_NEXT_STEP:
            return {
                ...state,
                currentStep: state.currentStep + 1
            };
        case ONBOARDING_PREVIOUS_STEP:
            return {
                ...state,
                currentStep: state.currentStep - 1
            };
        case ONBOARDING_ADD_STEP:
            return {
                ...state,
                stepData: [...state.stepData, action.pageData]
            };
        default:
            return state;
    }
}

export function fetchCurrentStepData() {
    return (dispatch, getState) => {
        const {
            abba: {
                config: {
                    onboarding: {
                        order
                    } = {}
                } = {}
            },
            onboarding: {
                currentStep,
                stepData
            },
            user: {
                email
            }
        } = getState();

        if (stepData[currentStep] && stepData[currentStep].page === STEP_NAMES.CONFIRMATION) {
            return Promise.resolve();
        }

        return fetchNextPage(email, stepData[currentStep - 1] && stepData[currentStep - 1].page, order)
            .then((responseData) => {
                dispatch({
                    type: ONBOARDING_ADD_STEP,
                    pageData: responseData
                });

                return responseData;
            });
    };
}

export function nextStep() {
    return (dispatch, getState) => {
        const {
            onboarding: {
                currentStep,
                stepData
            }
        } = getState();

        // don't change steps when one is loading or past the confirmation page
        if (!stepData[currentStep] || stepData[currentStep].page === STEP_NAMES.CONFIRMATION) {
            return;
        }

        dispatch({ type: ONBOARDING_NEXT_STEP });
    };
}

export function previousStep() {
    return (dispatch, getState) => {
        const {
            onboarding: {
                currentStep,
                stepData
            }
        } = getState();

        // don't change steps when one is loading or below 0
        if (!stepData[currentStep] || currentStep === 0) {
            return;
        }

        dispatch({ type: ONBOARDING_PREVIOUS_STEP });
    };
}

export default {
    fetchCurrentStepData,
    nextStep,
    previousStep
};
